var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"clock-btn",attrs:{"src":require("@/assets/clock-white.svg")},on:{"click":_vm.show}})
}
var staticRenderFns = []

export { render, staticRenderFns }